<template>
  <div class="public-icon-wrapper">
    <svg
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="public-icon"
      aria-hidden="true"
    >
      <!-- Régua de nível + seta de vazão -->
      <path class="fill" :style="{ fill: fillColor }" d="M0 4.80002H3.60001V7.20003H0V4.80002Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M0 12H3.60001V14.4001H0V12Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M0 8.40003H2.40001V10.8H0V8.40003Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M0 1.2H2.40001V3.60001H0V1.2Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M0 15.6001H2.40001V18.0001H0V15.6001Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M10.8 2.40001H13.2V7.20003H10.8V2.40001Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M19.2001 4.80002H16.8001V0L19.2001 1.43052e-07V4.80002Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M12 1.43052e-07L14.4001 3.60001H9.60004L12 1.43052e-07Z" />
      <path class="fill" :style="{ fill: fillColor }" d="M18.0001 7.20003L15.6001 3.60001L20.4001 3.60001L18.0001 7.20003Z" />
      <!-- Ondas d'água -->
      <path
        class="fill"
        :style="{ fill: fillColor }"
        d="M5.39182 15.1629C6.61318 14.5523 8.08837 14.7915 9.05394 15.7571L9.24847 15.9516C9.44259 16.1457 9.75749 16.1457 9.9516 15.9516C11.083 14.8202 12.9171 14.8202 14.0485 15.9516C14.2426 16.1457 14.5575 16.1457 14.7516 15.9516C15.883 14.8202 17.7171 14.8202 18.8485 15.9516C19.0426 16.1457 19.3575 16.1457 19.5516 15.9516C20.683 14.8202 22.5172 14.8202 23.6485 15.9516C24.1172 16.4203 24.1172 17.1799 23.6485 17.6485C23.1799 18.1171 22.4203 18.1171 21.9516 17.6485C21.7575 17.4544 21.4426 17.4544 21.2485 17.6485C20.1171 18.7799 18.283 18.7799 17.1516 17.6485C16.9575 17.4544 16.6426 17.4544 16.4485 17.6485C15.3171 18.7799 13.483 18.7799 12.3516 17.6485C12.1575 17.4544 11.8426 17.4544 11.6485 17.6485C10.5171 18.7799 8.68297 18.7799 7.55159 17.6485L7.35706 17.454C7.12204 17.219 6.76258 17.1602 6.46526 17.3087L5.33674 17.8735L4.2633 15.7266L5.39182 15.1629Z"
      />
      <path
        class="fill"
        :style="{ fill: fillColor }"
        d="M10.1461 12.1571C11.1117 11.1915 12.5869 10.9523 13.8083 11.5629L14.9368 12.1266C15.5296 12.423 15.7699 13.144 15.4735 13.7368C15.1771 14.3295 14.4561 14.5699 13.8633 14.2735L12.7348 13.7086C12.4375 13.5602 12.078 13.6189 11.843 13.854C10.6041 15.0926 8.59593 15.0926 7.35706 13.854C7.12204 13.6189 6.76258 13.5602 6.46526 13.7086L5.33674 14.2735L4.2633 12.1266L5.39182 11.5629C6.61318 10.9523 8.08837 11.1915 9.05394 12.1571C9.35555 12.4585 9.84452 12.4585 10.1461 12.1571Z"
      />
    </svg>
  </div>
</template>

<script>
// Ícone das estações públicas de terceiros (régua de nível + ondas). Mesmo contrato do
// LogoIcon: sem prop `color`, herda currentColor do container — é assim que o switch do
// mapa pinta o ícone de cinza quando inativo e de branco quando ativo.
export default {
  name: "PublicIcon",
  props: ["color"],
  data() {
    return {
      fillColor: this.color || "currentColor",
    };
  },
};
</script>

<style scoped>
/* Tamanho FIXO, como no BibliotecaIcon. O componente é usado no switch do mapa e no menu
   lateral, e cada um tem regras próprias de layout: dar largura ao wrapper (100%) fazia
   o ícone ocupar a linha inteira do menu e empurrar o rótulo para fora. Aqui ele ocupa
   só o próprio tamanho e deixa o container posicionar. */
.public-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.public-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.fill {
  fill: var(--icon-color, currentColor);
}
</style>
